<template>
    <UnidadeLayout>
        <!-- Loader padrão de página do sistema -->
        <LoaderPage v-if="carregando" />

        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-min-h-screen tw-transition-colors tw-duration-200">
            <div class="tw-mx-auto tw-px-6 tw-py-6 tw-space-y-6">
                
                <!-- SEÇÃO: Bloco do Cabeçalho Superior -->
                <div class="tw-flex tw-justify-between tw-items-center">
                    <div>
                        <h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-text-2xl tw-font-black tw-tracking-tight">
                            Minhas Unidades
                        </h2>
                        <p class="tw-text-sm tw-text-gray-500 tw-mt-0.5">
                            Visão consolidada, métricas de capacidade e barramento de comunicação.
                        </p>
                    </div>

                    <!-- Botões de Ação e Switch de Layout à Direita -->
                    <div class="tw-flex tw-items-center tw-gap-3">
                        <!-- Switch de Tipo de Visualização -->
                        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-slate-200 tw-border-slate-300'" class="tw-flex tw-p-1 tw-rounded-lg tw-border">
                            <button 
                                @click="viewMode = 'table'"
                                :class="viewMode === 'table' 
                                    ? (theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-800 tw-shadow-sm') 
                                    : 'tw-text-gray-400 hover:tw-text-gray-500'"
                                class="tw-px-3 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-bold tw-flex tw-items-center tw-gap-1 tw-transition-all"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-3.5 tw-h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                                </svg>
                                Tabela
                            </button>
                            <button 
                                @click="viewMode = 'cards'"
                                :class="viewMode === 'cards' 
                                    ? (theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-800 tw-shadow-sm') 
                                    : 'tw-text-gray-400 hover:tw-text-gray-500'"
                                class="tw-px-3 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-bold tw-flex tw-items-center tw-gap-1 tw-transition-all"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-3.5 tw-h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                </svg>
                                Cards
                            </button>
                        </div>

                        <router-link 
                            to="/v2/consulta-avancada"
                            :class="theme === 'dark'
                                ? 'tw-bg-zinc-800 hover:tw-bg-zinc-700 tw-text-white tw-border tw-border-zinc-700'
                                : 'tw-bg-slate-900 hover:tw-bg-slate-800 tw-text-white'"
                            class="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-shadow-sm tw-transition-all"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                            </svg>
                            <span>Consulta Avançada</span>
                        </router-link>
                    </div>
                </div>

                <!-- SEÇÃO: Bloco de Métricas de Cúpula (KPIs) com Vetores Nativos Corrigidos -->
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6">
                    <!-- Volume Consolidado -->
                    <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-white tw-border-slate-200'" class="tw-p-5 tw-rounded-2xl tw-border tw-shadow-2xl tw-flex tw-items-center tw-justify-between">
                        <div>
                            <span class="tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase">Volume Consolidado</span>
                            <div :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-text-2xl tw-font-extrabold tw-mt-1">
                                {{ formatarSacas(totalSacasEstoque) }} <span class="tw-text-xs tw-font-normal tw-text-gray-500">sc</span>
                            </div>
                        </div>
                        <div :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-amber-400' : 'tw-bg-amber-50 tw-text-amber-600'" class="tw-p-3 tw-rounded-xl tw-flex tw-items-center tw-justify-center">
                            <!-- Ícone Silo / Volume Armazenado -->
                            <svg class="tw-w-7 tw-h-7"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.7"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg">

                                <!-- teto -->
                                <path d="M7 6L12 2L17 6"/>

                                <!-- corpo -->
                                <path d="M7 6V17"/>
                                <path d="M17 6V17"/>

                                <!-- base arredondada -->
                                <path d="M7 17C7 20 9 22 12 22C15 22 17 20 17 17"/>

                                <!-- linha do volume -->
                                <path d="M8.5 11.5C10 10.7 11 11.8 12 11.8C13 11.8 14 10.7 15.5 11.5"/>

                                <!-- grãos -->
                                <ellipse cx="10" cy="15" rx="0.9" ry="1.2" fill="currentColor" stroke="none"/>
                                <ellipse cx="12" cy="16.2" rx="0.9" ry="1.2" fill="currentColor" stroke="none"/>
                                <ellipse cx="14" cy="15" rx="0.9" ry="1.2" fill="currentColor" stroke="none"/>

                                <!-- indicador lateral -->
                                <path d="M19.5 8V16"/>
                                <path d="M19.5 12H21"/>
                            </svg>
                        </div>
                    </div>

                    <!-- Unidades Vinculadas -->
                    <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-white tw-border-slate-200'" class="tw-p-5 tw-rounded-2xl tw-border tw-shadow-2xl tw-flex tw-items-center tw-justify-between">
                        <div>
                            <span class="tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase">Unidades Vinculadas</span>
                            <div :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-text-2xl tw-font-extrabold tw-mt-1">
                                {{ unidades.length }} <span class="tw-text-xs tw-font-normal tw-text-gray-500">plantas</span>
                            </div>
                        </div>
                        <div :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'" class="tw-p-3 tw-rounded-xl tw-flex tw-items-center tw-justify-center">
                                    <!-- Ícone Planta / Unidade -->
                            <svg class="tw-w-6 tw-h-6"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg">

                                <!-- prédio central -->
                                <rect x="9" y="4" width="6" height="16" rx="1.5"/>

                                <!-- silos laterais -->
                                <path d="M5 9v9"/>
                                <path d="M19 9v9"/>

                                <path d="M4 9h2"/>
                                <path d="M18 9h2"/>

                                <!-- janelas -->
                                <path d="M11 8h2"/>
                                <path d="M11 12h2"/>
                                <path d="M11 16h2"/>

                                <!-- base -->
                                <path d="M3 20h18"/>
                            </svg>
                        </div>
                    </div>

                    <!-- Filtro -->
                    <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-white tw-border-slate-200'" class="tw-p-4 tw-rounded-2xl tw-border tw-shadow-2xl tw-flex tw-items-center">
                        <div class="tw-w-full">
                            <span class="tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-block tw-mb-1">Localizar Unidade</span>
                            <input
                                v-model="filtroUnidade"
                                type="text"
                                :class="theme === 'dark' ? 'tw-bg-zinc-800 tw-text-white tw-border-zinc-700 focus:tw-ring-zinc-600' : 'tw-bg-slate-100 tw-text-gray-900 tw-border-transparent focus:tw-ring-slate-300'"
                                class="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border focus:tw-outline-none focus:tw-ring-1"
                                placeholder="Buscar pelo nome da unidade..."
                            />
                        </div>
                    </div>
                </div>

                <!-- MODO 1: Tabela Industrial Central -->
                <section v-if="!carregando && viewMode === 'table'" :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
                    <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-[#e9eef6] tw-border-[#d1d5db]'" class="tw-border-b tw-px-6 tw-py-4 tw-flex tw-items-center tw-gap-3">
                        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'" class="tw-p-2.5 tw-rounded-lg">
                            <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                            </svg>
                        </div>
                        <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Acompanhamento Técnico das Unidades</h3>
                    </div>

                    <div class="tw-overflow-x-auto">
                        <table class="tw-w-full">
                            <thead>
                                <tr :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">
                                    <th class="tw-px-6 tw-py-3.5 tw-text-left">Unidade Armazenadora</th>
                                    <th class="tw-px-6 tw-py-3.5 tw-text-center">Estação Clima</th>
                                    <th class="tw-px-6 tw-py-3.5 tw-text-center">Status de Comunicação</th>
                                    <th class="tw-px-6 tw-py-3.5 tw-text-center">Capacidade Ocupada</th>
                                    <th class="tw-px-6 tw-py-3.5 tw-text-center">Silos</th>
                                    <th class="tw-px-6 tw-py-3.5 tw-text-center">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr 
                                    v-for="unidade in unidadesFiltradas" 
                                    :key="unidade.id"
                                    :class="theme === 'dark' ? 'hover:tw-bg-slate-800/30 tw-border-slate-700 tw-text-slate-300' : 'hover:tw-bg-slate-50 tw-border-slate-200 tw-text-slate-700'"
                                    class="tw-border-t tw-cursor-pointer tw-transition-colors"
                                    @click="irParaUnidade(unidade.id)"
                                >
                                    <!-- Identificação (Utilizando imagem da Unidade em vez de logo) -->
                                    <td class="tw-px-6 tw-py-4.5 tw-text-sm tw-font-medium">
                                        <div class="tw-flex tw-items-center tw-gap-3.5">
                                            <img 
                                                v-if="unidade.imagem"
                                                :src="getImageUrl(unidade.imagem)" 
                                                :alt="unidade.unidade" 
                                                class="tw-w-14 tw-h-9 tw-rounded-lg tw-object-cover tw-bg-white tw-border dark:tw-border-zinc-800 tw-shadow-sm"
                                            />
                                            <div v-else class="tw-w-14 tw-h-9 tw-rounded-lg tw-bg-slate-200 dark:tw-bg-zinc-800 tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-black tw-text-gray-500">
                                                {{ unidade.unidade.substring(0, 2).toUpperCase() }}
                                            </div>
                                            <div>
                                                <span class="tw-block tw-font-bold">{{ unidade.unidade }}</span>
                                                <span class="tw-text-xs tw-font-normal tw-text-gray-400">ID: #00{{ unidade.id }}</span>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Clima -->
                                    <td class="tw-px-6 tw-py-4.5 tw-text-center tw-text-sm">
                                        <div v-if="unidade.estacao_meteorologica" class="tw-inline-flex tw-items-center tw-gap-4 tw-text-xs">
                                            <div>Temp: <span class="tw-font-bold tw-text-sm">{{ Math.round(unidade.estacao_meteorologica.temperatura) }}°C</span></div>
                                            <div class="tw-border-l dark:tw-border-slate-700 tw-h-4"></div>
                                            <div>Umid: <span class="tw-font-bold">{{ Math.round(unidade.estacao_meteorologica.umidade) }}%</span></div>
                                            <div class="tw-border-l dark:tw-border-slate-700 tw-h-4"></div>
                                            <div>
                                                Chuva: 
                                                <span :class="unidade.estacao_meteorologica.chuva ? 'tw-text-blue-500 tw-font-bold' : 'tw-text-gray-400'" class="tw-uppercase">
                                                    {{ unidade.estacao_meteorologica.chuva ? 'Sim' : 'Não' }}
                                                </span>
                                            </div>
                                        </div>
                                        <span v-else class="tw-text-gray-400 tw-text-xs tw-italic">Sem dados</span>
                                    </td>

                                    <!-- Comunicação -->
                                    <td class="tw-px-6 tw-py-4.5 tw-text-center text-sm" @click.stop>
                                        <div v-if="unidade.monitoramento" class="tw-inline-flex tw-flex-wrap tw-justify-center tw-gap-2 tw-text-xs">
                                            <span :class="unidade.monitoramento.estacao?.success ? 'tw-bg-emerald-500/10 tw-text-emerald-500' : 'tw-bg-red-500/10 tw-text-red-500'" class="tw-px-2.5 tw-py-0.5 tw-rounded-full tw-font-semibold">
                                                Estação: {{ unidade.monitoramento.estacao?.success ? 'OK' : 'FALHA' }}
                                            </span>
                                            <span :class="verificarSucessoGeral(unidade.monitoramento.aeracao) ? 'tw-bg-emerald-500/10 tw-text-emerald-500' : 'tw-bg-amber-500/10 tw-text-amber-500'" class="tw-px-2.5 tw-py-0.5 tw-rounded-full tw-font-semibold">
                                                Aeração: {{ contarSilosComSucesso(unidade.monitoramento.aeracao) }}
                                            </span>
                                            <span :class="verificarSucessoGeral(unidade.monitoramento.termometria) ? 'tw-bg-emerald-500/10 tw-text-emerald-500' : 'tw-bg-amber-500/10 tw-text-amber-500'" class="tw-px-2.5 tw-py-0.5 tw-rounded-full tw-font-semibold">
                                                Termometria: {{ contarSilosComSucesso(unidade.monitoramento.termometria) }}
                                            </span>
                                        </div>
                                        <span v-else class="tw-text-gray-400 tw-text-xs tw-italic">Sem telemetria</span>
                                    </td>

                                    <!-- Ocupação -->
                                    <td class="tw-px-6 tw-py-4.5 tw-text-sm">
                                        <div class="tw-max-w-[200px] tw-mx-auto tw-space-y-1">
                                            <div class="tw-flex tw-justify-between tw-text-xs">
                                                <span>{{ formatarSacas(unidade.armazenamento.ocupacao_atual_ton) }} / {{ formatarSacas(unidade.armazenamento.capacidade_total_ton) }} sc</span>
                                                <span class="tw-font-bold">{{ unidade.armazenamento.percentual_ocupacao }}%</span>
                                            </div>
                                            <div :class="theme === 'dark' ? 'tw-bg-slate-600' : 'tw-bg-slate-200'" class="tw-w-full tw-h-2 tw-rounded-full tw-overflow-hidden">
                                                <div :class="unidade.armazenamento.percentual_ocupacao > 90 ? 'tw-bg-amber-500' : 'tw-bg-emerald-500'" class="tw-h-full tw-transition-all" :style="{ width: `${Math.min(unidade.armazenamento.percentual_ocupacao, 100)}%` }"></div>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Silos -->
                                    <td class="tw-px-6 tw-py-4.5 tw-text-center tw-font-semibold tw-text-sm">
                                        {{ unidade.silos ? unidade.silos.length : 0 }}
                                    </td>

                                    <!-- Botão Ação Explícito -->
                                    <td class="tw-px-6 tw-py-4.5 tw-text-center">
                                        <span :class="theme === 'dark' ? 'tw-bg-slate-800 hover:tw-bg-slate-700 tw-text-blue-400' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-600'" class="tw-inline-block tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-bold tw-transition-colors">
                                            Ir para unidade
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <!-- MODO 2: Grid de Cards Clássicos Otimizados -->
                <div v-if="!carregando && viewMode === 'cards'" class="tw-flex tw-flex-wrap tw-justify-center tw-gap-4">
                    <CardUnidade 
                        v-for="unidade in unidadesMapeadasParaCards" 
                        :key="unidade.id" 
                        :unidade="unidade"
                    />
                </div>

                <!-- Estado Vazio -->
                <div v-if="!carregando && unidadesFiltradas.length === 0" class="tw-text-center tw-py-16">
                    <p class="tw-text-gray-500">Nenhum registro de unidade localizado.</p>
                </div>

            </div>
        </main>
    </UnidadeLayout>
</template>

<script>
import UnidadeLayout from "@/components/layouts/v2/UnidadeLayout.vue";
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import CardUnidade from "@/components/ui/v2/CardUnidade.vue"; // Rota de importação corrigida

import { ref, onMounted, computed } from "vue";
import { mapState, useStore } from "vuex";
import { useToast } from 'vue-toastification';
import { useRouter } from "vue-router";

export default {
    name: "UnidadesPage",
    components: {
        UnidadeLayout,
        LoaderPage,
        CardUnidade
    },
    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
        totalSacasEstoque() {
            return this.unidades.reduce((acc, unidade) => {
                return acc + (unidade.armazenamento?.ocupacao_atual_ton || 0);
            }, 0);
        },
        // Mapeia o payload hibrido alimentando as chaves exatas do seu CardUnidade (.nome, .imagem e .logo)
        unidadesMapeadasParaCards() {
            return this.unidadesFiltradas.map(u => ({
                id: u.id,
                nome: u.unidade,
                logo: u.logo,
                imagem: u.imagem,
                status: 'ativo'
            }));
        }
    },
    setup() {
        const store = useStore();
        const toast = useToast();
        const router = useRouter();
        
        const unidades = ref([]);
        const filtroUnidade = ref("");
        const carregando = ref(false);
        const viewMode = ref("table");

        onMounted(async () => {
            carregando.value = true;
            try {
                await store.dispatch("unidades/fetchUnidadesDetalhes");
                unidades.value = store.state.unidades.unidades_detalhes || [];
            } catch (error) {
                console.error("Erro ao carregar detalhes:", error);
                toast.error("Erro ao carregar métricas das unidades.");
            } finally {
                carregando.value = false;
            }
        });

        const irParaUnidade = (unidadeId) => {
            router.push(`/v2/unidades/${unidadeId}`);
        };

        const getImageUrl = (imagePath) => {
            if (!imagePath) return '';
            return `${process.env.VUE_APP_SERVER}/storage/${imagePath}`;
        };

        const formatarSacas = (sacas) => {
            if (!sacas || sacas <= 0) return '0';
            return new Intl.NumberFormat('pt-BR').format(sacas);
        };

        const verificarSucessoGeral = (arraySilos) => {
            if (!arraySilos || !Array.isArray(arraySilos) || arraySilos.length === 0) return false;
            return arraySilos.every(silo => silo.success === true);
        };

        const contarSilosComSucesso = (arraySilos) => {
            if (!arraySilos || !Array.isArray(arraySilos) || arraySilos.length === 0) return 'Sem dados';
            const total = arraySilos.length;
            const operantes = arraySilos.filter(silo => silo.success === true).length;
            
            if (operantes === total) return "OK";
            return `${operantes}/${total} OK`;
        };

        const unidadesFiltradas = computed(() => {
            if (!filtroUnidade.value) return unidades.value;
            return unidades.value.filter(u =>
                u.unidade && u.unidade.toLowerCase().includes(filtroUnidade.value.toLowerCase())
            );
        });

        return {
            unidades,
            unidadesFiltradas,
            filtroUnidade,
            carregando,
            viewMode,
            irParaUnidade,
            getImageUrl,
            formatarSacas,
            verificarSucessoGeral,
            contarSilosComSucesso
        };
    },
};
</script>